<template>
  <div>
    <h2 class="font-bold text-18px pb-0.5">Reports</h2>
    <template v-if="flights.length > 0">
      <FlightGenerateCard
        v-for="flight in flights"
        :key="flight.id"
        :name="flight.name"
        :flight="flight"
        :period="flight.flightPeriod"
        :is-ready="!!flight.report"
      />
    </template>

    <NoDataCard v-else v-loading="loading">
      <template slot="title">Reports not available yet</template>
      <template slot="info">Reports can be generated once the campaign is completed.</template>
    </NoDataCard>
  </div>
</template>
<script>
import NoDataCard from '@/components/social-products/social-boost/parts/NoDataCard.vue'
import FlightGenerateCard from '@/components/social-products/social-boost/parts/Report/FlightGenerateCard.vue'
import flights from '../../campaign/tabs/Flights.vue'

export default {
  components: {
    NoDataCard,
    FlightGenerateCard,
  },
  data() {
    return {
      flights: [],
      loading: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    pageLoading: {
      // getter
      get() {
        return this.$store.getters['app/SET_LOADING']
      },
      // setter
      set(newValue) {
        this.blockStateChange(() => this.$store.commit('app/SET_LOADING', newValue))
      },
    },
  },
  methods: {
    async init() {
      this.loading = true
      const campaign_id = this.$route.params.id
      const { data } = await this.axios.get(`/api/social-products/social-boost/campaign/${campaign_id}/completed-flights`)
      if (data) {
        data?.forEach((item) => {
          item.flightPeriod = this.$period(item.start_date, item.end_date)
          this.flights.push(item)
        })
      }
      this.loading = false
    },
  },
}
</script>
